import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "order-execute"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('Group', [_c('Cell', {
    attrs: {
      "value-align": "left",
      "title": i18n.tc("319")
    }
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.title) + " ")])], 1), _c('Group', [_c('Cell', {
    attrs: {
      "title": i18n.tc("320") + " ",
      "is-link": ""
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'ProjectDetail',
          params: {
            oid: _vm.oid
          }
        });
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#3ccba6"
    }
  }, [_vm._v(i18n.tc("316"))])])], 1), _vm.template.is_receipt === 1 ? [_c('div', {
    staticClass: "container-operation"
  }, [_c('group', [_vm.template.is_receipt_sign === 1 ? [_c('cell', {
    attrs: {
      "title": i18n.tc("321"),
      "border-intent": false
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#eb524a"
    },
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("*")])]), !_vm.user.receiptState ? _c('span', {
    staticStyle: {
      "color": "#3ccba6"
    },
    on: {
      "click": function ($event) {
        _vm.writeShow = true;
      }
    }
  }, [_vm._v(i18n.tc("322"))]) : _vm._e()]), [!_vm.service.sign ? _c('div', {
    staticClass: "signature font-size-h3-large",
    on: {
      "click": function ($event) {
        _vm.writeShow = true;
      }
    }
  }, [_vm._v(" " + i18n.tc("323") + " ")]) : _c('div', {
    staticClass: "signature font-size-h3-large"
  }, [_c('img', {
    attrs: {
      "src": _vm.service.sign
    }
  }), _c('p', [_vm._v(i18n.tc("324"))])])]] : _vm._e()], 2)], 1)] : _vm._e(), _c('WriteExecute', {
    attrs: {
      "default-event": false
    },
    on: {
      "on-success": function ($event) {
        ;
        _vm.service.sign = $event, _vm.writeShow = false;
      }
    },
    model: {
      value: _vm.writeShow,
      callback: function ($$v) {
        _vm.writeShow = $$v;
      },
      expression: "writeShow"
    }
  }), !_vm.user.receiptState ? _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom-btn-body"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary",
      "show-loading": _vm.loading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.uploadSign.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("325") + " ")])], 1)]) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };